export interface LeaderboardTeam {
  id: string
  name: string
  progress: number
  memberCount: number
  activityBreakdown: {
    [activityId: string]: number
  }
  restDayCount: number
  restDayTarget: number
  membersCompletedRestDays?: number
}

export interface LeaderboardArgument {
  leaderProgress: number
  teams: LeaderboardTeam[]
}

export default class Leaderboard {
  readonly leaderProgress: number
  readonly teams: LeaderboardTeam[]

  constructor(arg: LeaderboardArgument) {
    this.leaderProgress = arg.leaderProgress
    this.teams = arg.teams
  }
}
